import React, { useState, useEffect } from 'react';
import i18n from '../../../translate/i18n';

import Textarea from '../../Form/Textarea';
import TextareaEditor from '../../Form/TextareaEditor';
import Radio from '../../Form/Radio';

import ImgMenuPesquisa from '../../../assets/images/image-pesquisa.svg';

import './styles.css'
import { FaStar } from 'react-icons/fa'
import UploadFiles from 'components/Form/UploadFiles';


interface TypeProps {
  data: any,
  handleSelectChange: Function,
  handleInputChange: Function,
  setData: Function
}

export default function Conclusao({ data, handleSelectChange, handleInputChange, setData }: TypeProps) {

  /*
   * Causa e Conclusão vivem em ESTADO LOCAL, como já acontece no Croqui e nos
   * Órgãos Públicos.
   *
   * Ligar o editor direto ao `data` trava a tela: cada tecla reescreve o objeto,
   * o formulário inteiro re-renderiza, o editor recebe um `value` novo,
   * reformata o HTML e dispara `onChange` outra vez — laço sem fim, sem erro no
   * console. O estado local corta esse ciclo: o editor só responde a si mesmo.
   */
  const [causa, setCausa] = useState<string>(data?.causa || '');
  const [conclusao, setConclusao] = useState<string>(data?.conclusao || '');

  // A O.S. pode chegar depois da montagem: semeia quando aparecer, sem
  // sobrescrever o que a pessoa já tiver digitado.
  useEffect(() => { if (!causa && data?.causa) setCausa(data.causa); }, [data?.causa]);
  useEffect(() => { if (!conclusao && data?.conclusao) setConclusao(data.conclusao); }, [data?.conclusao]);

  // Espelha no formulário só quando muda de verdade. A forma funcional do
  // setData evita que os dois campos se sobrescrevam ao atualizar no mesmo ciclo.
  useEffect(() => {
    if (causa !== (data?.causa || '')) setData((prev: any) => ({ ...prev, causa }));
  }, [causa]);
  useEffect(() => {
    if (conclusao !== (data?.conclusao || '')) setData((prev: any) => ({ ...prev, conclusao }));
  }, [conclusao]);

  return (
    <div className='container-box'>
      <h5>{i18n.t<string>('edit.conclused')}</h5>
      <hr />
      <form >
        <Radio
          title="Regularidade"
          data={[
            { _id: 'regular', name: 'Regular' },
            { _id: 'irregular', name: 'Irregular' },
          ]}
          value={data?.regularidade || ''}
          setSelected={(value: string) => { handleSelectChange('regularidade', value) }}
        />
        {/*
          * Causa e Conclusão usam o mesmo editor das outras etapas (Croqui,
          * Órgãos, Pesquisas). São textos que vão inteiros para o relatório da
          * seguradora — negrito e lista mudam a leitura de quem analisa.
          *
          * O editor devolve o VALOR (não um evento), então não dá para reusar o
          * `handleInputChange`, que lê `event.target`.
          */}
        <TextareaEditor
          name="causa"
          label="Causa"
          placeholder={'Digite aqui a causa'}
          data={causa}
          setData={(value: string) => setCausa(value)}
        />
        <TextareaEditor
          name="conclusao"
          label="Conclusão"
          placeholder={'Digite aqui a conclusão'}
          data={conclusao}
          setData={(value: string) => setConclusao(value)}
        />
        <Textarea
          name="feedback"
          label="Feedback"
          placeholder={'Deixe o seu feedback'}
          data={data?.feedback || ''}
          setData={handleInputChange}
        />
        {
          data.id &&
          <UploadFiles
            name="images"
            label="Inserir imagens e/ou documentos dos tipos: PNG, JPEG, JPG e PDF"
            osId={data?.id}
            etapa={'conclusao'}
          />
        }
        <div className="field">
          <h4>Queremos muito saber sua opinião ou comentários sobre como podemos melhorar sua experiência conosco! Responda nossa pesquisa, é rapidinho:</h4>
          <a href={'https://forms.gle/s9nbhNF3vwCBvEFM7'} className='container-box card-menu m-2 d-flex justify-content-center' target='_blank'>
            <img src={ImgMenuPesquisa} />
            <span><h4 className='pt-2'>Opine para melhorarmos!</h4></span>
          </a>
        </div>
      </form>
    </div>
  )
}
